  document.addEventListener('DOMContentLoaded', function() {
    let dataColors = [];
    let colorsJson = window.theme.assets.swatches;
    let variantID = 0;
    fetch(colorsJson)
      .then(response => {
        // Check if the response is ok (status code in the range 200-299)
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        // Parse the JSON data
        return response.json();
      })
      .then(data => {
        // Use the retrieved data
        // Function to get hex value by color name
        // Example usage
        dataColors = data.colors;
      })
      .catch(error => {
        // Handle any errors
        console.error('There was a problem with the fetch operation:', error);
      });
    function initVariant(){
      let mattressProductTitle = document.querySelector('.mattress-product-title').value;
      switch (mattressProductTitle) {
        case 'cooling-hybrid-mattress':
          document.querySelector('#zinusPremierRadio--2 input').checked = true;
          document.querySelector('#materialHybrid input').checked = true;
          document.querySelector('#zinusOriginalRadio').classList.add('hidden');
          document.querySelector('#zinusPremierRadio--3').classList.remove('opacity');
          document.querySelector('#zinusPremierRadio--2').classList.remove('opacity');
          break;
        case 'original-hybrid-mattress':
          document.querySelector('#zinusOriginalRadio input').checked = true;
          document.querySelector('#materialHybrid input').checked = true;
          document.querySelector('#zinusPremierRadio--3').classList.add('hidden');
          document.querySelector('#zinusOriginalRadio').classList.remove('opacity');
          document.querySelector('#zinusPremierRadio--2').classList.remove('opacity');
          break;
        case 'ultra-hybrid-mattress':
          document.querySelector('#materialHybrid input').checked = true;
          document.querySelector('#zinusPremierRadio--3 input').checked = true;
          document.querySelector('.pdp-variant-1-text').classList.add('hidden');
          document.querySelector('#zinusOriginalRadio').classList.add('hidden');
          document.querySelector('#zinusPremierRadio--2').classList.add('hidden');
          document.querySelector('#zinusPremierRadio--3').classList.add('hidden');
          break;
        case 'original-green-tea':
          document.querySelector('#zinusOriginalRadio input').checked = true;
          document.querySelector('#materialMemoryFoam input').checked = true;
          document.querySelector('#zinusPremierRadio--3').classList.add('hidden');
          document.querySelector('#zinusOriginalRadio').classList.remove('opacity');
          document.querySelector('#zinusPremierRadio--2').classList.remove('opacity');
          break;
        case 'ultra-green-tea':
          document.querySelector('.pdp-variant-1-text').classList.add('hidden');
          document.querySelector('#materialMemoryFoam input').checked = true;
          document.querySelector('#zinusPremierRadio--3 input').checked = true;
          document.querySelector('#zinusOriginalRadio').classList.add('hidden');
          document.querySelector('#zinusPremierRadio--2').classList.add('hidden');
          document.querySelector('#zinusPremierRadio--3').classList.add('hidden');
          break;
        case 'cooling-green-tea':
          document.querySelector('#zinusPremierRadio--2 input').checked = true;
          document.querySelector('#materialMemoryFoam input').checked = true;
          document.querySelector('#zinusOriginalRadio').classList.add('hidden');
          document.querySelector('#zinusPremierRadio--3').classList.remove('opacity');
          document.querySelector('#zinusPremierRadio--2').classList.remove('opacity');
          break; 
        default:
      }
      let collectionHandle = sessionStorage.getItem('lastCollectionHandle');
      let collectionTitle = sessionStorage.getItem('lastCollectionTitle');
      if(document.querySelector('.breadcrumbs__collection-link') && collectionTitle && collectionTitle){
        document.querySelector('.breadcrumbs__collection-link').textContent = collectionTitle;
        document.querySelector('.breadcrumbs__collection-link').href = collectionHandle;
      }
    }
    
    function toggleVariant() {
      document.querySelector('.select-popout__toggle').addEventListener('click', function(){
        var isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);
        document.querySelector('.zin-select-popout__list').classList.toggle('select-popout__list--visible');
      })
    }

    async function customWidget(variantId) {
      let dataId = document.querySelector('.cross_products-wrapper')?.dataset.widgetId;
      let variantID = variantId;
      let productId = document.querySelector('custom-product').dataset.productId;
      let matchOption = document.querySelector('.select-popout__list__scroll .select-popout__item--current span')?.textContent.trim();
      const res = await fetch(`https://wapi.zinus.com/api/rebuy-proxy?data_id=${dataId}&product_ids=${productId}&variant_ids=${variantID}`);
      const data = await res.json();
      // let dataUrl = `https://rebuyengine.com/api/v1/custom/id/${dataId}?shopify_product_ids=${productId}&shopify_variant_ids=${variantID}&metafields=yes`;
      // console.log(dataUrl, 'dataUrl');
      // fetch(dataUrl)
      //   .then(response => response.json())
      //   .then(data => {
          let crossProducts = data.data;
          let firstSelectedColorName = '';
          let productsBody = '';
          crossProducts.forEach(item => {
            let descriptions = '';
            let hideVariants = '';
            if(item.metafields){
              item.metafields.forEach(metafield => {
                if(metafield.key == "cross_description"){
                  descriptions = metafield.value;
                }
              })
            }

            if(item.id == '7691544461375'){
              hideVariants = 'hidden';
            }
            
           productsBody += `<li class="product__form" data-product-part="">
                  <input type="hidden" name="id" value="${item.variants[0].id}" data-product-select="" data-product-available="true">
                  <div class="cross_product-item" role="group" aria-label="product" data-product-id="${item.id}" data-handle="${item.handle}">
                  <div class="cross_product-image">
                    <img src="${item.image.src}" width="100" height="100" alt="${item.image.alt}">
                  </div>
                  <div class="cross_product-details" data-variant-sku="${item.variants[0].sku}">
                    <div class="title-with-price">
                      <button class="cross_product-checked" aria-pressed="false" aria-label="Add ${item.title}">
                        <span class="icon-plus" aria-hidden="true">
                          <svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m13.5113 6.026h-5.53803v-5.538h-1.924v5.538h-5.563996v1.924h5.563996v5.564h1.924v-5.564h5.53803z" fill="currentColor"></path></svg>
                        </span>
                        <span class="add_button">Add</span>
                      </button>
                      ` +
                      item.variants.map((card, index) => {
                          let option = '';
                          let hideComparePrice = '';
                          let variantName = card.title;
                          if (!card.title.includes(matchOption) || index > 0) {
                            option = 'hidden';
                          }
                          
                          if (card.compare_at_price === card.price || !card.compare_at_price) {
                              hideComparePrice = 'hidden';
                          }
                          return `<div class="price-wrapper ${option}" role="button" tabindex="0" data-variant-name='${variantName}' data-variant-id="${card.id}" data-inventory-quantity="${card.inventory_quantity}">
                                      <h4 class='product_title'>${item.title}</h4>
                                      <div class="variant-with-price">
                                          <span class='variant_option'>(${matchOption})</span>
                                          <span class="variant_price" data-price="${card.price}">$${card.price}</span>
                                          <span class="product__price--compare ${hideComparePrice}">$${card.compare_at_price}</span>
                                      </div>
                                  </div>`;
                      }).join('') + `
                      </div>
                      <div class="item_options ${hideVariants}">`+
                          item.options.map(option => {
                            if(option.name.trim() != 'Size' && option.name.trim() != 'size'){
                              if(option.name.trim() == 'Color'){
                                let returnText = `<fieldset class="radio__fieldset" role="radiogroup" aria-labelledby="color-label-${option.name}"><legend id="color-label-${option.name}" class="sr-only">Choose a color</legend>`
                                for(index in option.values){
                                  let colorName = option.values[index].toLowerCase(); // Change this to any color name you want
                                  let hexColor = getHexValue(dataColors, colorName);
                                  let hexValue = hexColor[colorName];
                                  let colorType = hexColor.type;
                                  let colorTypeValue = '';
                                  if(colorType == 'dark'){
                                    colorTypeValue = 'dark';
                                  }else if(colorType == 'light'){
                                    colorTypeValue = 'light'
                                  }
                                  let currentItem = '';
                                  let ariaChecked = '';
                                  let optionValue = option.values[index].replace(' ', '-');
                                  let input_id = `${option.id}-${option.product_id}-${option.name}-${optionValue}`;
                                  let name = `${option.name}--${option.product_id}`;
                                  if(index == 0){
                                    currentItem = 'checked';
                                    ariaChecked = true;
                                    firstSelectedColorName = `${option.values[index]}`;
                                  }
                                  returnText += `<span class="swatch__button" data-tooltip="${option.values[index]}" role="button" tabindex="0"><input type="radio"
                                    class="swatch__input variant_radio_input sr-only"
                                    data-single-option-selector
                                    data-index="option"
                                    name="${name}"
                                    value="${option.values[index]}"
                                    id="${input_id}"
                                    aria-checked="${ariaChecked}"
                                    ${currentItem}>
                                    <label for="${input_id}" class="swatch__label ${colorTypeValue}" title="${option.values[index]}" data-swatch="${option.values[index]}" style="background-color: ${hexValue};">
                                    <span class="visually-hidden">${option.values[index]}</span>
                                  </label></span>`
                                }

                                // close fieldset + attach a tiny self-executing updater script
                                returnText += `</fieldset> <p>Color: <strong class="selected_color-name">${firstSelectedColorName}</strong></p>`;

                                return returnText;
                              }

                              else{
                                let ariaLabelledby = `select-${option.name}-label`;
                                let ariaControls=`select-${option.name}`
                                let returnText = `<select-popout class="select-popup__item select-popout"><label id="height-label" class="sr-only">Select Height</label><button type="button" class="select-popout__toggle" role="combobox" aria-controls="${ariaControls}" aria-labelledby="height-label select-popout-text" aria-activedescendant="custom-option-0" aria-expanded="false"  aria-haspopup="listbox"><span id="select-popout-text" class="select-popout__value" data-popout-text>${option.values[0]}
                                </span><svg xmlns="http://www.w3.org/2000/svg" class="icon-select" width="24" height="24" viewBox="0 0 24 24">
                                  <polygon points="12 17.414 3.293 8.707 4.707 7.293 12 14.586 19.293 7.293 20.707 8.707 12 17.414"/>
                                </svg></button><ul class="select-popout__list custom-select-popout__list__scroll select-popout__list__scroll" id="${ariaLabelledby}" aria-labelledby="height-label" role="listbox" tabindex="-1"  data-popout-list>`
                                for(index in option.values){
                                  let currentItem = '';
                                  let ariaSelected = '';
                                  if(index == 0){
                                    currentItem = 'select-popout__item--current';
                                    ariaSelected = true
                                  }
                                  returnText += `<li class="select-popout__item ${currentItem}" role="option" id="custom-option-${index}" aria-selected="${ariaSelected}">
                                                  <span class="select-popout__option" data-value='${option.values[index]}' data-popout-option>
                                                    <span data-value="${option.values[index]}">${option.values[index]}</span>
                                                  </span>
                                                </li>`
                                }
                                returnText += `</ul></select-popout>`
                                return returnText;
                              }
                            }
                        }).join('')+
                      `</div>
                      <div class="cross_product-description"><p>${descriptions}</p></div>
                    </div>
                  </div></li>`;
          });
        
          document.querySelector('.cross_products-wrapper').innerHTML = productsBody;
          productWidget();
          document.querySelectorAll('.rebuy_cross-wrapper .cross_product-item').forEach(item => {
            let popoutText = document.querySelector('.select-popout__item--current span').textContent.trim();
            console.log(popoutText, 'popoutText');
            let variantTitle = item.querySelector(`.title-with-price .price-wrapper`).dataset.variantName;
            if(variantTitle.includes(popoutText)){
              item.classList.remove('hidden');
            }else{
              item.classList.add('hidden');
            }
            if(item.querySelector('.title-with-price .price-wrapper:not(.hidden)').dataset.inventoryQuantity < 1){
              item.classList.add('hidden');
            }
          })
          document.querySelectorAll('.rebuy_cross-wrapper .select-popout__toggle').forEach(item => {
            item.addEventListener('keydown', (e) => {
              switch(e.key) {
                  case 'ArrowUp':
                      e.preventDefault();
                      selectPreviousOption(item);
                      break;
        
                  case 'ArrowDown':
                      e.preventDefault();
                      selectNextOption(item);
                      break;

                  case 'Tab':
                      item.setAttribute('aria-expanded', false);
                      item.closest('.select-popout').querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
                  break;
                      
                  case 'Escape':
                    e.preventDefault();
                    item.closest('.select-popout').querySelector('.select-popout__list__scroll .select-popout__item--current .select-popout__option').click();
                  break;
    
                  case 'Enter':
                    e.preventDefault();
                    if(item.closest('.select-popout').querySelector('.select-popout__list').classList.contains('select-popout__list--visible')){
                      item.closest('.select-popout').querySelector('.select-popout__list__scroll .select-popout__item--current .select-popout__option').click();
                    }else{
                      item.setAttribute('aria-expanded', true);
                      item.closest('.select-popout').querySelector('.select-popout__list').classList.add('select-popout__list--visible')
                    }
                  break;
              }
            });
          })
          rebuyOptionSelector();
          crossKeydown();
          crossProductKeyBoard();
        // });
    }

    function getHexValue(dataColors, colorName) {
    // Loop through each object in the array
      for (const color of dataColors) {
        // Check if the color name exists in the object
        if (color[colorName]) {
          return color; // Return the hex value
        }
      }
      
    }

    function getColorValue(dataColors, colorName) {
      // Loop through each object in the array
      for (const color of dataColors) {
        // Check if the color name exists in the object
        if (color[colorName]) {
          return color[colorName]; // Return the hex value
        }
      }
      
    }

    document.querySelector('.custom_checkbox').addEventListener('keydown', (e) => {
      if(e.code == 'Space' || e.key == 'Enter'){
        e.preventDefault();
        e.stopPropagation();
        let checkbox = document.querySelector('.custom_checkbox');
        let isChecked = checkbox.getAttribute('aria-checked') === 'true';
        checkbox.setAttribute('aria-checked', !isChecked);
        document.querySelector('.cross_widget #cross_widget').click();
      }
    })

    /* keyboard function */

    function keyDown(){
      document.querySelectorAll('.select-popout__toggle').forEach(item => {
        item.addEventListener('keydown', (e) => {
          switch(e.key) {
              case 'ArrowUp':
                  e.preventDefault();
                  selectPreviousOption(item);
                  break;
    
              case 'ArrowDown':
                  e.preventDefault();
                  selectNextOption(item);
                  break;

              case 'Tab':
                  item.setAttribute('aria-expanded', false);
                  item.closest('select-popout').querySelector('.zin-select-popout__list').classList.remove('select-popout__list--visible');
              break;
                  
              case 'Escape':
                e.preventDefault();
                item.closest('.select-popout').querySelector('.custom-select-popout__list__scroll .select-popout__item--current .select-popout__option').click();
                document.querySelector('.select-popout__toggle').focus();
              break;

              case 'Enter':
                e.preventDefault();
                if(item.closest('.select-popout').querySelector('.select-popout__list').classList.contains('select-popout__list--visible')){
                  item.closest('.select-popout').querySelector('.custom-select-popout__list__scroll .select-popout__item--current .select-popout__option').click();
                }else{
                  item.setAttribute('aria-expanded', true);
                  item.closest('.select-popout').querySelector('.select-popout__list').classList.add('select-popout__list--visible');
                }
              break;
          }
        });
      })
    }

    function selectPreviousOption(item) {
      let currentOption = item.closest('.select-popout').querySelector('.select-popout__item--current');
      let options = item.closest('.select-popout').querySelectorAll('.custom-select-popout__list__scroll .select-popout__item');
      if (currentOption) {
          const currentOptionIndex = Array.prototype.indexOf.call(options, currentOption);
          if (currentOptionIndex - 1 >= 0) {
              const previousOption = options[currentOptionIndex - 1];
              currentOption.classList.remove('select-popout__item--current');
              previousOption.classList.add('select-popout__item--current'); // Select the previous option
              document.querySelectorAll('.custom-select-popout__list__scroll .select-popout__item').forEach(element =>{
                element.setAttribute('aria-selected', false);
              })
              previousOption.setAttribute('aria-selected', true);
              let id = previousOption.getAttribute('id');
              previousOption.closest('select-popout').querySelector('.select-popout__toggle').setAttribute('aria-activedescendant', id)
          }
      }
    }

    function selectNextOption(item) {
      let currentOption = item.closest('.select-popout').querySelector('.select-popout__item--current');
      let options = item.closest('.select-popout').querySelectorAll('.custom-select-popout__list__scroll .select-popout__item');
      if(currentOption !== undefined) {
        var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
        if(currentOptionIndex + 1 < options.length) {
            var nextOption = options[currentOptionIndex + 1];
            currentOption.classList.remove('select-popout__item--current');
            document.querySelectorAll('.custom-select-popout__list__scroll .select-popout__item').forEach(element =>{
              element.setAttribute('aria-selected', false);
            })
            nextOption.classList.add('select-popout__item--current'); // Select the previous option
            nextOption.setAttribute('aria-selected', true);
            let id = nextOption.getAttribute('id');
            nextOption.closest('select-popout').querySelector('.select-popout__toggle').setAttribute('aria-activedescendant', id)
        }
      }
    }

    function crossKeydown() {
      document.querySelectorAll('.cross_products-wrapper .swatch__button').forEach(item => {
        item.addEventListener('keydown', (e) => {
          if(e.code == 'Space' || e.key == 'Enter'){
            e.preventDefault();
            item.querySelector('.swatch__input').click();
          }
          if(e.code == 'Escape'){
            item.blur();
          }
        });
      })
    }

    function crossProductKeyBoard(){
      document.querySelectorAll('.cross_product-item .price-wrapper').forEach(element => {
        element?.addEventListener('keydown', (e) =>{
          
          if(e.code == 'Space' || e.key == 'Enter'){
            if(e.target.classList.contains('price-wrapper')){
              e.preventDefault();
              e.stopPropagation();
              let item = element.closest('.cross_product-item');
              let productHandle = item.dataset.handle;
              let selectedVariantId =  item.closest('[data-product-part]').querySelector('[data-product-select]').value;
              let checkAddButton = '';
              let textButton = 'Add';
              let variantTitle = item.querySelector('.cross_product-details').querySelector('.product_title').textContent.trim();
              let variantPrice = item.querySelector('.cross_product-details').querySelector('.variant-with-price .variant_price').dataset.price;
              let variantSku = item.querySelector('.cross_product-details').dataset.variantSku;
              let variantId = item.closest('[data-product-part]').querySelector('[data-product-select]').value;
              let container = '.popup-mulberry-inner'
              if(item.querySelector('.cross_product-checked').classList.contains('button_clicked')){
                checkAddButton = 'button_clicked';
                textButton = 'Added';
              }
              let productsBody = '';
              let getMetafieldsUrl = `https://zinus.com/products/${productHandle}?view=view`;
              fetch(getMetafieldsUrl)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok: ' + response.statusText);
                    }
                    return response.text(); // Read the response body as text
                })
                .then(data => {
                    quickViewDescription = data;
                    let productUrl = `https://zinus.com/products/${productHandle}.js`;
                    let sizeValue = document.querySelector('.select-popout__item--current span')?.textContent.trim();
                    fetch(productUrl)
                      .then(response => {
                          if (!response.ok) {
                          throw new Error('Network response was not ok ' + response.statusText);
                          }
                          return response.json();
                      })
                      .then(data => {
                          
                          let item = data;
                          productsBody += `<span class="close_popup"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 192 192"><path d="M150 42 42 150M150 150 42 42" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/></svg></span>
                                  <form method="post" action="/cart/add" class="product__form" enctype="multipart/form-data" data-product-form="" data-product-part>
                                    <input type="hidden" name="id" value="${selectedVariantId}" data-product-select="">
                                    <div class="mulberry-id"></div>
                                    <input type="hidden" class="rebuy-attribution" name="properties[_attribution]" value="Rebuy Product" />
                                    <input type="hidden" class="rebuy-source" name="properties[_source]" value="Rebuy" />
                                    <input type="hidden" class="rebuy-widget-id" name="properties[_widget_id]" value="166634" />
                                    <input type="hidden" class="mulberry-product-id" name="properties[mulberry]" value="" />
                                    <div class="cross_product-item" role="button" tabindex="0" data-product-id="${item.id}" data-handle="${item.handle}">
                                      <div class="rebuy-quick-view__body__inner">
                                        <div class="cross_product-image">
                                          <img src="${item.featured_image}" alt="${item.featured_image.alt}">
                                        </div>
                                      </div>
                                      <div class="cross_product-details">
                                        <label for="cross_product">
                                          <span class='product_title'>${item.title}</span>
                                        </label>
                                        <div class="item_options">`+
                                          item.options.map(option => {
                                            if(option.name.trim() == 'Color'){
                                              let returnText = `<label>${option.name}</label><fieldset class="radio__fieldset">`
                                              for(index in option.values){
                                                let colorName = option.values[index].toLowerCase(); // Change this to any color name you want
                                                let hexColor = getHexValue(dataColors, colorName);
                                                let hexValue = hexColor[colorName];
                                                let colorType = hexColor.type;
                                                let colorTypeValue = '';
                                                if(colorType == 'dark'){
                                                  colorTypeValue = 'dark';
                                                }else if(colorType == 'light'){
                                                  colorTypeValue = 'light'
                                                }
                                                let currentItem = '';
                                                let optionValue = option.values[index].replace(' ', '-');
                                                let input_id = `${option.id}-${option.product_id}-${option.name}-${optionValue}`;
                                                if(index == 0){
                                                  currentItem = 'checked';
                                                }
                                                returnText += `<span class="swatch__button"><input type="radio"
                                                  class="swatch__input variant_radio_input sr-only"
                                                  data-single-option-selector
                                                  data-index="option"
                                                  name="${option.name}"
                                                  value="${option.values[index]}"
                                                  id="${input_id}"
                                                  ${currentItem}>
                                                  <label for="${input_id}" class="swatch__label ${colorTypeValue}" data-swatch="${option.values[index]}" data-tooltip="${option.values[index]}" style="background-color: ${hexValue};" 
                                                  tabindex="0">
                                                  <span class="visually-hidden">${option.values[index]}</span>
                                                </label></span>`
                                              }
                                              returnText += `</fieldset>`
                                              return returnText;
                                            }else{
                                              if(option.name.trim() != 'Size'){
                                                let returnText = `<fieldset class="radio__fieldset"><legend class="radio__legend">
                                                    <span class="radio__legend__label">${option.name}</span></legend>`
                                                for(index in option.values){
                                                  let currentItem = '';
                                                  let optionValue = option.values[index].replace(' ', '-');
                                                  let input_id = `${option.id}-${option.product_id}-${option.name}-${optionValue}`;
                                                  if(index == 0){
                                                    currentItem = 'checked';
                                                  }
                                                  if(index == 0){
                                                    currentItem = 'checked';
                                                  }
                                                  returnText += `<span class="radio__button">
                                                      <input
                                                        type="radio"
                                                        class="radio__input variant_radio_input sr-only"
                                                        data-single-option-selector
                                                        data-index="option{{ option.position }}"
                                                        name="${option.name}"
                                                        value='${option.values[index]}'
                                                        id="${input_id}"
                                                        ${currentItem}>
                                                      <label for="${input_id}" class="radio__label">
                                                        <span>${option.values[index]}</span>
                                                      </label>
                                                    </span>`
                                                }
                                                returnText += `</fieldset>`
                                                return returnText;
                                              }
                                            }
                                          }).join('')+`
                                        </div>
                                        <div class="title-with-price">`+
                                          item.variants.map((card, index) => {
                                            if(index < 1){
                                              let option = '';
                                              let hideComparePrice = '';
                                              let variantName = card.title;
                                              let cardPrice = Number(card.price/100).toFixed(2);
                                              if (card.compare_at_price === card.price || !card.compare_at_price) {
                                                  hideComparePrice = 'hidden';
                                              }
                                              
                                              return `<div class="price-wrapper ${option}" data-variant-name='${variantName}' data-variant-id="${card.id}" data-inventory-quantity="${card.inventory_quantity}">
                                                          <div class="variant-with-price">
                                                              <span class="sizeValue">(${sizeValue})</span>
                                                              <span class="variant_price" data-price="${cardPrice}">$${cardPrice}</span>
                                                              <span class="product__price--compare ${hideComparePrice}">$${card.compare_at_price}</span>
                                                          </div>
                                                      </div>`;
                                            }
                                          }).join('') + `
                                          <button class="cross_product-checked ${checkAddButton}" type="submit" name="add" data-add-to-cart>
                                            <span class="icon-plus">
                                              <svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m13.5113 6.026h-5.53803v-5.538h-1.924v5.538h-5.563996v1.924h5.563996v5.564h1.924v-5.564h5.53803z" fill="currentColor"></path></svg>
                                            </span>
                                            <span class="add_button">${textButton}</span>
                                          </button>
                                        </div>
                                        <div class="popup-mulberry-inner"></div>
                                        <span class="quick_purchase_button">I don't want to protect my purchase</span>
                                        <div class='product_description'>${quickViewDescription}</div>
                                      </div>
                                    </div>
                                  </form>`;
                                  document.querySelector('.rebuy_popup-wrapper').innerHTML = productsBody;
                                  document.querySelector('.popup-overlay').classList.add('active');
                                  document.querySelector('body').classList.add('overflow');
                                  popupVariantSwap();
                                  productPopupWidget();
                                  document.querySelector('.close_popup').addEventListener('click', function(){
                                    document.querySelector('.popup-overlay').classList.remove('active');
                                    document.querySelector('body').classList.remove('overflow');
                                  })
                                  document.querySelector('.quick_purchase_button').addEventListener('click', function(){
                                    document.querySelector('.rebuy_popup-wrapper .mulberry-id').innerHTML = '';
                                    document.querySelector('.rebuy_popup-wrapper .cross_product-checked').click();
                                  })
                        })
                      .catch(error => {
                          console.error('There was a problem with the fetch operation:', error);
                    });
                })
                .catch(error => {
                    console.error('There was a problem with the fetch operation:', error);
              });
              initializeMulberry(variantTitle, variantPrice, variantSku, variantId, container);
            }
          }
        })
      })
    }

    async function checkForMulberryToken(ms = 100, triesLeft = 100) {
      return new Promise((resolve, reject) => {
        if (window?.mulberry?.core?.publicToken) {
          resolve(true);
        }
        const interval = setInterval(async () => {
          if (window?.mulberry?.core?.publicToken) {
            resolve(true);
            clearInterval(interval);
          } else if (triesLeft <= 1) {
            resolve(false);
            clearInterval(interval);
          }
          triesLeft--;
        }, ms);
      });
    }

    async function initializeMulberry(variantTitle, variantPrice, variantSku, variantId, container) {
      document.querySelector('.rebuy-mulberry-inline').innerHTML = '';
      if(document.querySelector('.popup-mulberry-inner'))
        document.querySelector('.popup-mulberry-inner').innerHTML = '';
      document.querySelector('.rebuy-mulberry-inline_wrapper .mulberry-id').innerHTML = '';
      document.querySelectorAll('.mulberry-product-id').forEach(item =>{
        item.value='';
      })
      if(document.querySelector('.rebuy_popup-wrapper .mulberry-id')){
        document.querySelector('.rebuy_popup-wrapper .mulberry-id').innerHTML = '';
      }
      window.mulberry.core.init({
        publicToken: 'zLHKJyjbN1MyxRnXHwSvcgq-gMk'
      });
      async function setMulberrySelectedWarranty(warranty){
        let mulberrySelectedWarranty = warranty;
        if (mulberrySelectedWarranty) {
          try {
            // Prepare the request parameters
            const params = new URLSearchParams({
              product_price: mulberrySelectedWarranty.product.price,
              duration_months: mulberrySelectedWarranty.duration_months,
              insurer_category: mulberrySelectedWarranty.insurer_category
            });
        
            // Await the fetch call
            const response = await fetch(`https://ottawa.getmulberry.com/api/prices?${params}`, {
              method: 'GET',
              headers: {
                'Authorization': 'Bearer zLHKJyjbN1MyxRnXHwSvcgq-gMk',
                'Content-Type': 'application/json' // Optional
              }
            });
        
            // Check if the response is OK
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
        
            // Await the JSON parsing
            const data = await response.json();
            const shopifyMulberryVariantId = data.shopify_variant_id;
            document.querySelector('.rebuy-mulberry-inline_wrapper .mulberry-id').innerHTML = `<input type="hidden" name="items[1][id]" value="${shopifyMulberryVariantId}" data-mulberry-id>`;
            document.querySelectorAll('.mulberry-product-id').forEach(item =>{
              item.value=shopifyMulberryVariantId;
            })
            if(document.querySelector('.rebuy_popup-wrapper .mulberry-id'))
              document.querySelector('.rebuy_popup-wrapper .mulberry-id').innerHTML = `<input type="hidden" name="items[1][id]" value="${shopifyMulberryVariantId}" data-mulberry-id>`;
          } catch (error) {
            console.error('Unable to fetch mulberry variant ID', error);
          }
        }else{
          document.querySelector('.rebuy-mulberry-inline_wrapper .mulberry-id').innerHTML = '';
          if(document.querySelector('.rebuy_popup-wrapper .mulberry-id')){
            document.querySelector('.rebuy_popup-wrapper .mulberry-id').innerHTML = '';
          }
        }
      }

      checkForMulberryToken();
    
      const offers = await mulberry.core.getWarrantyOffer({
        title: variantTitle,
        id: variantSku,
        price: variantPrice
      });
      document.querySelector('.mulberry-popup [data-product-id]').value = variantId;
      mulberry.inline.init({
        offers: offers,
        settings: mulberry.core.settings,
        selector: container,
        onWarrantyToggle: warranty => {
          if (warranty.isSelected) {
            return setMulberrySelectedWarranty(warranty.offer);
          }

          setMulberrySelectedWarranty(null);
        }
      });
      if(container == '.rebuy-mulberry-inline'){
        setTimeout(() => {
          document.querySelector('.mulberry-popup').classList.add('active');
        }, 1000);
      }
    }

    function productWidget(){
      document.querySelectorAll('.rebuy_cross-wrapper .cross_product-checked').forEach((item, index) => {
        item.addEventListener('click', function(e){
          let productId = item.closest('.cross_product-item').dataset.productId;
          if(item.classList.contains('button_clicked')){
            document.querySelectorAll(`.cross_product-item[data-product-id="${productId}"]`).forEach(card => {
              card.closest('[data-product-part]').querySelector('.cross_product-checked').classList.remove('button_clicked');
              card.querySelector('.add_button').textContent = 'Add';
            })
            e.preventDefault();
            e.stopPropagation();
            if(document.querySelector(`.cart-drawer__items .cart__item__content[data-item-id="${productId}"]`).querySelector('.cart__item__remove'))
              document.querySelector(`.cart-drawer__items .cart__item__content[data-item-id="${productId}"]`).querySelector('.cart__item__remove').click();
          }else{
            document.querySelectorAll(`.cross_product-item[data-product-id="${productId}"]`).forEach(card => {
              card.closest('[data-product-part]').querySelector('.cross_product-checked').classList.add('button_clicked');
              card.querySelector('.add_button').textContent = 'Added';
            })
            let variantTitle = item.closest('.cross_product-details').querySelector('.product_title').textContent.trim();
            let variantPrice = item.closest('.cross_product-details').querySelector('.variant-with-price .variant_price').dataset.price;
            let variantSku = item.closest('.cross_product-details').dataset.variantSku;
            let variantId = item.closest('[data-product-part]').querySelector('[data-product-select]').value;
            let container = '.rebuy-mulberry-inline';
            initializeMulberry(variantTitle, variantPrice, variantSku, variantId, container);
            document.querySelector('.close_mulberry_popup').addEventListener('click', function(){
              document.querySelector('.mulberry-popup').classList.remove('active');
              
              document.querySelectorAll(`.cross_product-item[data-product-id="${productId}"]`).forEach(card => {
                card.closest('[data-product-part]').querySelector('.cross_product-checked').classList.remove('button_clicked');
                card.querySelector('.add_button').textContent = 'Add';
              })
            })
            document.querySelector('.mulberry-add-button').addEventListener('click', function(){
              document.querySelector('.mulberry-popup').classList.remove('active');
            })

            document.querySelector('.purchase_button').addEventListener('click', function(){
              document.querySelector('.rebuy-mulberry-inline_wrapper .mulberry-id').innerHTML = '';
              document.querySelector('.mulberry-add-button').click();
            })
          }   
          // addToCart(productId, 1);

        })
      })
    }

    function productPopupWidget(){
      document.querySelectorAll('.rebuy_popup-wrapper .cross_product-checked').forEach((item, index) => {
        item.addEventListener('click', function(e){
          let productId = item.closest('.cross_product-item').dataset.productId;
          if(item.classList.contains('button_clicked')){
            document.querySelectorAll(`.cross_product-item[data-product-id="${productId}"]`).forEach(card => {
              card.closest('[data-product-part]').querySelector('.cross_product-checked').classList.remove('button_clicked');
              card.querySelector('.add_button').textContent = 'Add';
            })
            e.preventDefault();
            e.stopPropagation();
            if(document.querySelector(`.cart-drawer__items .cart__item__content[data-item-id="${productId}"]`).querySelector('.cart__item__remove'))
              document.querySelector(`.cart-drawer__items .cart__item__content[data-item-id="${productId}"]`).querySelector('.cart__item__remove').click();
          }else{
            document.querySelector('.rebuy-mulberry-inline').innerHTML = '';
            document.querySelectorAll(`.cross_product-item[data-product-id="${productId}"]`).forEach(card => {
              card.closest('[data-product-part]').querySelector('.cross_product-checked').classList.add('button_clicked');
              card.querySelector('.add_button').textContent = 'Added';
            })
            
          }

          // addToCart(productId, 1);

        })
      })
    }

    document.querySelectorAll('.zin-radio__button').forEach(item => {
      item.querySelector('.zin-radio__label')?.addEventListener('keydown', (e) => {
        switch(e.key) {
            case 'Enter':
              e.preventDefault();
              localStorage.setItem('zinusSelectedRadio', item.id);
              item.querySelector('.radio__input').click();
            break;
        }
      });
    })
    const savedId = localStorage.getItem('zinusSelectedRadio');
    if (savedId) {
      const input = document.getElementById(savedId);
      if (input) {
        input.focus();
        input.checked = true;
      }
      localStorage.removeItem("zinusSelectedRadio")
    }

    initSwiper();

    keyDown();

    initVariant();

    swapProduct();
    
    quickView();

    let variantTotalPrice= [];

    document.querySelectorAll('.variants-wrapper .variant_item').forEach(variantItem => {
      variantTotalPrice.push(variantItem.dataset.totalValue);
    })

    document.querySelectorAll(".select-popout__list__scroll .price-with-total").forEach((item, i) => {
      if (!variantTotalPrice[i].includes('$0.00')) {
        item.querySelector('.total_price').innerHTML = `${variantTotalPrice[i]}`;
      }
    })

    document.querySelectorAll(".select-popout__list__scroll").forEach(element => {
      element.querySelectorAll(".price-with-total").forEach((item, i) => {
        if (!variantTotalPrice[i].includes('$0.00')) {
          item.querySelector('.total_price').innerHTML = `${variantTotalPrice[i]}`;
        }
      })
    })

    document.querySelector('.sticky-variant_wrapper .select-popout__toggle').addEventListener('click', function(){
      let status = this.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
      this.setAttribute('aria-expanded', status);
      this.closest('select-popout').querySelector('.zin-select-popout__list').classList.toggle('select-popout__list--visible');
    })

    document.querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(button => {
      button.addEventListener('click', function(e){
        let popoutText = this.querySelector('.select-popout__option').dataset.value;
        let optionPrice = this.querySelector('.option_price').innerHTML;
        let totalPrice = this.querySelector('.total_price').innerHTML;
        let savePercentage = this.querySelector('.product__price--off').dataset.salePercent;
        let selectedId = this.getAttribute('id');
        this.closest('select-popout').querySelector('.select-popout__toggle').setAttribute('aria-activedescendant', selectedId);
        document.querySelectorAll('.zin-select-popout__list .select-popout__list__scroll .select-popout__item').forEach(element =>{
          element.setAttribute('aria-selected', false);
        })
        this.setAttribute('aria-selected', true);

        if(document.querySelector('.cross_products-wrapper')){
          document.querySelectorAll('.cross_products-wrapper .cross_product-item').forEach(item => {
            item.querySelector('.variant-with-price .variant_option').textContent = popoutText;
            item.querySelectorAll('.title-with-price label .price-wrapper').forEach(card => {
              card.classList.add('hidden');
            })
            if(item.querySelector(`.title-with-price label .price-wrapper[data-variant-name = ${popoutText}]`)){
              item.classList.remove('hidden');
              item.querySelector(`.title-with-price label .price-wrapper[data-variant-name = ${popoutText}]`).classList.remove('hidden');
            }else{
              item.classList.add('hidden');
            }
          })

          document.querySelectorAll('.cross_product-item').forEach(item => {
            let productId = item.dataset.productId;
            let variantId = item.querySelector('.title-with-price .price-wrapper:not(.hidden)')?.dataset.variantId;
            if(document.querySelector(`.custom_widget-products [data-variant-id="${productId}"]`))
              document.querySelector(`.custom_widget-products [data-variant-id="${productId}"]`).value = variantId;
            if(item.querySelector('.title-with-price .price-wrapper:not(.hidden)')?.dataset.inventoryQuantity < 1){
              item.classList.add('hidden');
            }else{
              item.classList.remove('hidden');
            }       
          })
        }
        document.querySelector('.sticky-variant_wrapper .select-popout__value').textContent = popoutText;
        document.querySelectorAll('.sticky-select-popout__item')?.forEach(item => {
          if(item.querySelector('.select-popout__option').dataset.value == popoutText){
            item.classList.add('select-popout__item--current');
          }else{
            item.classList.remove('select-popout__item--current');
          }
        })

        let currentId = document.querySelector('[data-current-id]').dataset.currentId;
        if(currentId == '10739097352' || currentId == '1965874839615' ){
          if(popoutText == 'Twin'){
            document.querySelector('#zinusPremierRadio--3').classList.add('hidden');
          }else{
            document.querySelector('#zinusPremierRadio--3').classList.remove('hidden');
          }
        }
        document.querySelectorAll('.product-variant__image')?.forEach(element => {
          element.closest('.product-wrapper__item').querySelector('.atc_button').classList.add('hidden');
          element.closest('.product-wrapper__item').querySelector('.shop_now').classList.remove('hidden');
        })
        document.querySelector(`.find-perfect-product [data-product-id="${currentId}"]`)?.querySelector('.shop_now').classList.add('hidden');
        document.querySelector(`.find-perfect-product [data-product-id="${currentId}"]`)?.querySelector('.atc_button').classList.remove('hidden');
        document.querySelector('.selected_option .option_price').innerHTML = optionPrice;
        document.querySelector('.sticky-selected_option .sticky-option_price').innerHTML = optionPrice;
        document.querySelectorAll('.zinus-perfect-product .price-with-button .variant_price').forEach(item => {
          if(item.dataset.variantTitle.trim().includes(popoutText)){
            item.classList.remove('hidden')
          }else{
            item.classList.add('hidden');
          }
        })
        document.querySelectorAll('.variants-wrapper .variant_item').forEach(variantItem => {
          let variantTitle = variantItem.dataset.variantTitle;
          if(variantTitle.includes(popoutText)){
            let mattressHeight = variantItem.dataset.height;
            variantID = variantItem.dataset.variantId;
            let varuantQt = variantItem.dataset.qty;
            document.querySelector('[data-selected-id').dataset.selectedId = variantID;
            getUpsellProduct(variantID, varuantQt);
            let savePrice = variantItem.dataset.savePrice;
            if(!savePrice.includes('$0.00')){
              document.querySelectorAll('.compare_at_price').forEach(item => {
                item.textContent = '+' + savePrice;
              });
            }else{
              document.querySelectorAll('.compare_at_price').forEach(item => {
                item.textContent = '';
              });
            }
            document.querySelectorAll('.mattress-height').forEach(button => {
              button.value = mattressHeight;
            })

            let cross_product = JSON.parse(document.querySelector('.cross_widget [type="application/json"]').textContent);
            let currentSelectedOption = document.querySelector('.select-popout__list__scroll .select-popout__item--current span').textContent.trim();
            let hide = false;
            cross_product.forEach(variant => {
              if(variant.title.includes(currentSelectedOption)){
                document.querySelector('.cross_widget .product_title').dataset.productId = variant.id;
                let price = (variant.price / 100).toFixed(2);
                document.querySelector('.cross_widget .variant_price').innerHTML = '(+$'+price+')';
                if (variant.available) {
                  hide = true;
                }
              }
            })
            
            if(document.querySelector('.cross_widget #cross_widget').checked){
              let variantId = document.querySelector('.cross_widget .product_title').dataset.productId;
              document.querySelector('.cross_widget_product').innerHTML = `<input type="hidden" name="items[1][id]" value="${variantId}">`;
              document.querySelector('.upsell-products__id-wrapper').innerHTML = `<input type="hidden" name="items[2][id]" value="${variantId}">`;
            }else{
              document.querySelector('.cross_widget_product').innerHTML = '';
              document.querySelector('.upsell-products__id-wrapper').innerHTML = '';
            }

            if(!hide){
              document.querySelector('.cross_widget').classList.add('hidden');
              document.querySelector('.upsell-products__id-wrapper').innerHTML = '';
              document.querySelector('.cross_widget_product').innerHTML = '';
            }else{
              let variantId = document.querySelector('.cross_widget .product_title').dataset.productId;
              document.querySelector('.cross_widget').classList.remove('hidden');
              document.querySelector('.upsell-products__id-wrapper').innerHTML = `<input type="hidden" name="items[2][id]" value="${variantId}">`;
              document.querySelector('.cross_widget_product').innerHTML = `<input type="hidden" name="items[1][id]" value="${variantId}">`;
            }

            if(document.querySelector('.product__submit__item.atc_button:not(.hidden)'))
              document.querySelector('.product__submit__item.atc_button:not(.hidden)').closest('.price-with-button').querySelector('[data-product-select]').value = variantID;
            
            if(document.querySelector('.cross_products-wrapper')){
              customWidget(variantID);
            }
          }
          variantTotalPrice.push(variantItem.dataset.totalValue);
        })

        if (!totalPrice.includes('$0.00')) {
          document.querySelector('.selected_option .total_price').innerHTML = totalPrice;
          document.querySelector('.sticky-selected_option .sticky-total_price').innerHTML = totalPrice;
          document.querySelector('.selected_option .product__price--off').classList.remove('hidden');
          document.querySelector('.selected_option .product__price--off').innerHTML = `Save ${savePercentage}% OFF`;
          document.querySelector('.sticky-selected_option .product__price--off').innerHTML = `Save ${savePercentage}% OFF`;
        }
        if(this.closest('.sticky-atc') && window.innerWidth < 767) {
          document.querySelector('.sticky-atc .select-popout__list').classList.add('select-popout__list--visible');
          document.querySelector('.sticky-atc .select-popout__toggle').setAttribute('aria-expanded', true);
        }
        let productHandle = document.querySelector('[data-product-handle]').dataset.productHandle;
        fetch(`/products/${productHandle}.js`)
        .then(res => res.json())
        .then(product => {
          let variant = product.variants.find(v => v.title === popoutText);
          if(variant.available){
            document.querySelector('.atc-button').classList.add('actived');
            document.querySelector('.notify-button').classList.remove('actived');
            document.querySelector('.sticky-add-to-cart__btn').textContent = 'Add To Cart';
          }else{
            document.querySelector('.atc-button').classList.remove('actived');
            document.querySelector('.notify-button').classList.add('actived');
            document.querySelector('.sticky-add-to-cart__btn').textContent = 'Notify Me';
          }
        });
        
      })
    })

    async function getUpsellProduct(variantID, varuantQt){
      if(document.querySelector('.upsell-popup__wrapper')){
        let productId = document.querySelector('.upsell-popup__container .product__id').value;
        document.querySelector('.upsell-popup__container [data-product-id]').value = productId;
        let dataId = document.querySelector('.upsell-popup__wrapper').dataset.upsellId;
        let response = await fetch(`https://wapi.zinus.com/api/rebuy-proxy?data_id=${dataId}&product_ids=${productId}&variant_ids=${variantID}`);
        let svg = `<svg width="10" height="20" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.71367 9.62V0.379999H6.29367V9.62H3.71367ZM0.253672 6.22V3.78H9.77367V6.22H0.253672Z" fill="#60BF98"/>
                  </svg>`
        let data = await response.json();
        let upsellProduct = data.data;
        console.log(varuantQt, 'varuantQt');
        if(upsellProduct.length > 0 && varuantQt > 0){
          document.querySelectorAll('.upsell-popup__button').forEach(button => {
            button.classList.remove('hidden');
          });
          document.querySelector('.product_add_to_cart-button .product__submit__item').classList.add('hidden');
          document.querySelector('.sticky-add-to-cart__btn').classList.add('hidden');
          let options = [];
          let popoutText = document.querySelector('.select-popout__list__scroll .select-popout__item--current span').textContent.trim();
          options.push(popoutText);
          
          let originVariantJson = document.querySelector('[data-product-json]').textContent;
          originVariantJson = JSON.parse(originVariantJson);
          let currentVariant = originVariantJson.variants.find((variant) => {
            return !variant.options.map((option, index) => {
              return options[index] === option;
            }).includes(false);
          });
          
          let salePrice = document.querySelector('.pdp-variant-1 .compare_at_price').textContent;
          if(salePrice){
            document.querySelector('.upsell-product__info .real_price').textContent = salePrice;
          }else{
            document.querySelector('.upsell-product__info .real_price').textContent = '+$0';
          }
          
          document.querySelector('.upsell-popup__container [data-product-id]').value = currentVariant.id;
          document.querySelector('.upsell-popup__container .upsell-product__id').value = upsellProduct[0].variants[0].id;
          document.querySelector('.upsell-popup__container .product__id').value = currentVariant.id;
          let parentElement = document.querySelector('.upsell-product__details');
          let childElement = document.querySelector('.upsell-product__details .upgrades');
          if(parentElement && childElement){
            parentElement.removeChild(childElement);
          }

          let parentImgElement = document.querySelector('.upsell-popup__image');
          let childImgElement = document.querySelector('.upsell-popup__image img');
          if(parentImgElement && childImgElement){
            parentImgElement.removeChild(childImgElement);
          }
          
          // Find the mattress_property_info metafield
          let mattressPropertyInfo = upsellProduct[0].metafields.find(metafield => metafield.key === 'upsell_product_property_info');
          let upsellMainImage = upsellProduct[0].metafields.find(metafield => metafield.key === 'upsell_product_main_image');
          let upsellPropertyImage = upsellProduct[0].metafields.find(metafield => metafield.key === 'upsell_product_property_image');
          let upsellBadge = upsellProduct[0].metafields.find(metafield => metafield.key === 'upsell_product_badge');
          let upsellBadgeBackground = upsellProduct[0].metafields.find(metafield => metafield.key === 'upsell_product_badge_bg_color');
          let upsellProductTitle = upsellProduct[0].metafields.find(metafield => metafield.key === 'upsell_product_title');
          let upsellProductHeading = upsellProduct[0].metafields.find(metafield => metafield.key === 'upsell_product_heading');
          
          document.querySelectorAll('.upsell-product__title').forEach(element => {
            element.textContent = upsellProductTitle.value;
          })

          document.querySelector('.popup-description').textContent = upsellProductHeading.value;

          document.querySelector('.upsell-product__origin-title').textContent = upsellProduct[0].title;
          // Create the container for the upgrades
          const upgradesContainer = document.createElement('div');
          upgradesContainer.classList.add('upgrades');

          // Create the image container and set the image source and alt text
          const imageContainer = document.createElement('div');
          imageContainer.classList.add('upgrades-image');
          const img = document.createElement('img');
          img.classList.add('original_image');
          if(upsellPropertyImage.value){
            img.src = upsellPropertyImage.value;
            img.alt = upsellProduct[0].title;
          }else{
            img.src = upsellProduct[0].image.src;
            img.alt = upsellProduct[0].image.alt;
          }
          imageContainer.appendChild(img);

          if(upsellMainImage.value){
            const mainImage = document.createElement('img');
            mainImage.src = upsellMainImage.value;
            mainImage.alt = 'upsell product image';
            document.querySelector('.upsell-popup__image').appendChild(mainImage);
          }

          if(upsellBadge.value){
            document.querySelector('.upsell-product__badge').textContent = upsellBadge.value;
            document.querySelector('.upsell-product__badge').style.background = upsellBadgeBackground.value;
          }
          // Create the textbox container
          const textBox = document.createElement('div');
          textBox.classList.add('upgrades-textbox');
          mattressPropertyInfo.value = JSON.parse(mattressPropertyInfo.value);
          mattressPropertyInfo.value.forEach((value) => {
            const textDiv = document.createElement('div');
            textDiv.classList.add('upgrades-text');

            // Assuming svg is already defined in your code, insert it here
            const svgElement = document.createElement('span'); // If svg is an image
            svgElement.innerHTML = svg;

            // Append the SVG and the value
            textDiv.appendChild(svgElement);
            textDiv.innerHTML += value; // Append the text value

            // Append each textDiv to the textBox
            textBox.appendChild(textDiv);
          });

          // Append the imageContainer and textBox to the upgradesContainer
          upgradesContainer.appendChild(imageContainer);
          upgradesContainer.appendChild(textBox);

          // Now, append the complete container to the relevant part of the DOM
          document.querySelector('.upsell-product__details').appendChild(upgradesContainer);
        }else{
          document.querySelectorAll('.upsell-popup__button').forEach(button => {
            button.classList.add('hidden');
          });
          document.querySelector('.product_add_to_cart-button .product__submit__item').classList.remove('hidden');
          document.querySelector('.sticky-add-to-cart__btn').classList.remove('hidden');

        }
      }
    }


    document.querySelectorAll('.sticky-select-popout__item').forEach(item => {
      item.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        let selectedItem = item.querySelector('.select-popout__option').dataset.value;
        let selectedPrice = item.querySelector('.option_price').textContent.trim();
        document.querySelector(`.select-popout__list__scroll .select-popout__option[data-value="${selectedItem}"]`).click();
        document.querySelectorAll('.sticky-select-popout__item').forEach(element => {
          element.classList.remove('select-popout__item--current');
        })
        this.classList.add('select-popout__item--current');
        if(this.classList.contains('sold-out')){
          document.querySelector('.sticky-atc .select-popout').classList.add('sold-out');
        }else{
          document.querySelector('.sticky-atc .select-popout').classList.remove('sold-out');
        }
        this.closest('select-popout').querySelector('.select-popout__toggle').setAttribute('aria-expanded', 'false');
        this.closest('select-popout').querySelector('.zin-select-popout__list').classList.remove('select-popout__list--visible');
        this.closest('select-popout').querySelector('.select-popout__toggle .select-popout__value').textContent = selectedItem;
        this.closest('select-popout').querySelector('.select-popout__toggle .sticky-option_price').textContent = selectedPrice;
      })
    })

    document.querySelector('.sticky-add-to-cart__btn').addEventListener('click', function(){
      document.querySelector('.product_add_to_cart-button .product__submit__add.actived').click();
    })
    document.querySelector('.sticky-custom_buy-now').addEventListener('click', function(){
      document.querySelector('.custom-buy-button').click();
    })

    function rebuyOptionSelector(){
      document.querySelectorAll('.cross_product-item')?.forEach(item => {

        item.querySelectorAll('.select-popout__toggle').forEach(button => {
          button.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            if(button.closest('.select-popup__item').querySelector('.select-popout__list').classList.contains('select-popout__list--visible')){
              this.setAttribute('aria-expanded', 'false');
              button.closest('.select-popup__item').querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
            }else{
              this.setAttribute('aria-expanded', 'true');
              button.closest('.select-popup__item').querySelector('.select-popout__list').classList.add('select-popout__list--visible');
            }
          })
        })

        item.querySelectorAll('.item_options .select-popup__item').forEach(itenOption => {
          itenOption.querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(popupItem => {
            popupItem.addEventListener('click', function(e){
              e.preventDefault();
              e.stopPropagation();
              let selectedTitle = popupItem.querySelector('.select-popout__option').dataset.value;
              itenOption.querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(item => {
                item.classList.remove('select-popout__item--current');
              })
              popupItem.classList.add('select-popout__item--current');
              let selectedId = popupItem.closest('.select-popout__item').getAttribute('id');
              popupItem.closest('.select-popup__item').querySelector('.select-popout__toggle').setAttribute('aria-activedescendant', selectedId);
              popupItem.classList.add('select-popout__item--current');
              document.querySelectorAll('#select-Height-label .select-popout__item').forEach(element =>{
                element.setAttribute('aria-selected', false);
              })
              popupItem.setAttribute('aria-selected', true);
              popupItem.closest('.select-popup__item').querySelector('.select-popout__value').textContent = selectedTitle;
              popupItem.closest('.select-popup__item').querySelector('.select-popout__toggle').setAttribute('aria-expanded', 'false');
              popupItem.closest('.select-popup__item').querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
              swatchVariants(item);
            })
          })
        })

        item.querySelectorAll('.item_options .swatch__button').forEach(option => {
          option.querySelector('.swatch__input').addEventListener('click', function(){
            swatchVariants(item);
          })
        })
        
      })
    }

    function swatchVariants(item, filtertext=''){
      let colors = item.querySelectorAll('.item_options .swatch__button');
      let options = [];
      let productUrl = `https://zinus.com/products/${item.dataset.handle}.js`;
      let size = document.querySelector('.select-popout__list__scroll .select-popout__item--current span')?.textContent.trim();
      let height = item.querySelector('.select-popup__item .select-popout__item--current span')?.dataset.value;
      if(filtertext == 'popup'){
        document.querySelectorAll('.rebuy_popup-wrapper .radio__fieldset').forEach(item => {
          let value = item.querySelector('.variant_radio_input:checked').value;
          options.push(value);
        })
        options.push(size);
      }else{
        colors.forEach(selectedColor => {
          if(selectedColor.querySelector('input[type="radio"]:checked')){
            let color = selectedColor.querySelector('input[type="radio"]:checked').value;
            if (!color) return;
            item.querySelector('.selected_color-name').textContent = color;
            options.push(color);
          }
        })
        if(height){
          options.push(height);
        }
        if(size){
          options.push(size);
        }
      }

      fetch(productUrl)
          .then(response => {
              if (!response.ok) {
              throw new Error('Network response was not ok ' + response.statusText);
              }
              return response.json();
          })
          .then(data => {
              let variantJson = data.variants;
              let currentVariant = variantJson.find((variant) => {
                return !variant.options.map((option, index) => {
                  return options[index] === option;
                }).includes(false);
              });
              console.log(currentVariant, 'currentVariant');
              if (!currentVariant){
                return;
              }
              let variantPrice = (currentVariant.price / 100).toFixed(2);
              let variantComparePrice = (currentVariant.compare_at_price / 100).toFixed(2);
              if(currentVariant.compare_at_price != null){
                item.querySelector('.title-with-price').querySelector('.price-wrapper:not(.hidden) .product__price--compare').textContent = '$'+variantComparePrice;
              }
              item.querySelector('.title-with-price').querySelector('.price-wrapper:not(.hidden)').dataset.variantId = currentVariant.id;
              item.querySelector('.title-with-price').querySelector('.price-wrapper:not(.hidden) .variant_price').textContent = '$'+variantPrice;
              item.closest(`[data-product-part]`).querySelector('.cross_product-details').dataset.variantSku = currentVariant.sku;
              item.closest(`[data-product-part]`).querySelector('[data-product-select]').value = currentVariant.id;
              item.closest(`[data-product-part]`).querySelector('[data-product-select]').dataset.productAvailable = currentVariant.available;
              item.querySelector('.cross_product-image img').src = currentVariant.featured_image.src;
              if(currentVariant.available){
                item.querySelector('.cross_product-checked').disabled = false;
                item.querySelector('.cross_product-checked .icon-plus').classList.remove('hidden');
                item.querySelector('.cross_product-checked .add_button').textContent = 'Add'
              }else{
                item.querySelector('.cross_product-checked').disabled = true;
                item.querySelector('.cross_product-checked .icon-plus').classList.add('hidden');
                item.querySelector('.cross_product-checked .add_button').textContent = 'Sold Out'
              }
            })
          .catch(error => {
              console.error('There was a problem with the fetch operation:', error);
      });
    }

    function popupVariantSwap (){
      document.querySelectorAll('.rebuy_popup-wrapper .cross_product-item')?.forEach(item => {
        item.querySelectorAll('.item_options .swatch__button').forEach(option => {
          option.querySelector('.swatch__input').addEventListener('click', function(){
            swatchVariants(item, 'popup');
          })
        })

        item.querySelectorAll('.item_options .radio__button').forEach(option => {
          option.querySelector('.radio__input').addEventListener('click', function(){
            swatchVariants(item, 'popup');
          })
        })
        
      })
    }

    function quickView(){
      document.querySelector('.cross_products-wrapper').addEventListener('click', function(e){
        let quickViewDescription = '';
        if(!e.target.classList.contains('swatch__label') && !e.target.classList.contains('swatch__input') && !e.target.classList.contains('cross_product-checked')){
            let productHandle = e.target.closest('.cross_product-item').dataset.handle;
            let selectedVariantId =  e.target.closest('[data-product-part]').querySelector('[data-product-select]').value;
            let checkAddButton = '';
            let textButton = '';
            let disabledButton = '';
            let variantTitle = e.target.closest('.cross_product-details').querySelector('.product_title').textContent.trim();
            let variantPrice = e.target.closest('.cross_product-details').querySelector('.variant-with-price .variant_price').dataset.price;
            let variantSku = e.target.closest('.cross_product-details').dataset.variantSku;
            let variantId = e.target.closest('[data-product-part]').querySelector('[data-product-select]').value;
            let container = '.popup-mulberry-inner'
            let selectedColor = e.target.closest('[data-product-part]').querySelector('.variant_radio_input:checked')?.value;
            let selectedSize = e.target.closest('[data-product-part]').querySelector('.select-popout__value')?.textContent;
            let quantityAvailable = e.target.closest('[data-product-part]').querySelector('[data-product-select]').dataset.productAvailable;
            if(quantityAvailable == 'true'){
              textButton = 'Add';
            }else{
              textButton = 'Sold Out'
              disabledButton = 'disabled';
            }
            // if(e.target.closest('.cross_product-item').querySelector('.cross_product-checked').classList.contains('button_clicked')){
            //   checkAddButton = 'button_clicked';
            //   textButton = 'Added';
            // }
            let productsBody = '';
            let getMetafieldsUrl = `https://zinus.com/products/${productHandle}?view=view`;
            fetch(getMetafieldsUrl)
              .then(response => {
                  if (!response.ok) {
                      throw new Error('Network response was not ok: ' + response.statusText);
                  }
                  return response.text(); // Read the response body as text
              })
              .then(data => {
                  quickViewDescription = data;
                  let productUrl = `https://zinus.com/products/${productHandle}.js`;
                  let sizeValue = document.querySelector('.select-popout__list__scroll .select-popout__item--current span')?.textContent.trim();
                  fetch(productUrl)
                    .then(response => {
                        if (!response.ok) {
                        throw new Error('Network response was not ok ' + response.statusText);
                        }
                        return response.json();
                    })
                    .then(data => {
                        
                        let item = data;
                        productsBody += `<span class="close_popup"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 192 192"><path d="M150 42 42 150M150 150 42 42" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/></svg></span>
                                <form method="post" action="/cart/add" class="product__form" enctype="multipart/form-data" data-product-form="" data-product-part>
                                  <input type="hidden" name="id" value="${selectedVariantId}" data-product-select="">
                                  <div class="mulberry-id"></div>
                                  <input type="hidden" class="rebuy-attribution" name="properties[_attribution]" value="Rebuy Product" />
                                  <input type="hidden" class="rebuy-source" name="properties[_source]" value="Rebuy" />
                                  <input type="hidden" class="rebuy-widget-id" name="properties[_widget_id]" value="166634" />
                                  <input type="hidden" class="mulberry-product-id" name="properties[mulberry]" value="" />
                                  <div class="cross_product-item" data-product-id="${item.id}" data-handle="${item.handle}">
                                    <div class="rebuy-quick-view__body__inner">
                                      <div class="cross_product-image">
                                        <img src="${item.featured_image}" alt="${item.featured_image.alt}">
                                      </div>
                                    </div>
                                    <div class="cross_product-details">
                                      <label for="cross_product">
                                        <span class='product_title'>${item.title}</span>
                                      </label>
                                      <div class="item_options">`+
                                        item.options.map(option => {
                                          if(option.name.trim() == 'Color'){
                                            let returnText = `<label>${option.name}</label><fieldset class="radio__fieldset">`
                                            for(index in option.values){
                                              let colorName = option.values[index].toLowerCase(); // Change this to any color name you want
                                              let hexValue = getColorValue(dataColors, colorName);
                                              let currentItem = '';
                                              let optionValue = option.values[index].replace(' ', '-');
                                              let input_id = `${option.id}-${option.product_id}-${option.name}-${optionValue}`;
                                              if(option.values[index].trim() == selectedColor.trim()){
                                                currentItem = 'checked';
                                              }
                                              returnText += `<span class="swatch__button"><input type="radio"
                                                class="swatch__input variant_radio_input"
                                                data-single-option-selector
                                                data-index="option"
                                                name="${option.name}"
                                                value="${option.values[index]}"
                                                id="${input_id}"
                                                ${currentItem}>
                                                <label for="${input_id}" class="swatch__label" data-swatch="${option.values[index]}" data-tooltip="${option.values[index]}" style="background-color: ${hexValue};">
                                                <span class="visually-hidden">${option.values[index]}</span>
                                              </label></span>`
                                            }
                                            returnText += `</fieldset>`
                                            return returnText;
                                          }else{
                                            if(option.name.trim() != 'Size'){
                                              let returnText = `<fieldset class="radio__fieldset"><legend class="radio__legend">
                                                  <span class="radio__legend__label">${option.name}</span></legend>`
                                              for(index in option.values){
                                                let currentItem = '';
                                                let optionValue = option.values[index].replace(' ', '-');
                                                let input_id = `${option.id}-${option.product_id}-${option.name}-${optionValue}`;
                                                if(option.values[index].trim() == selectedSize.trim()){
                                                  currentItem = 'checked';
                                                }
                                                returnText += `<span class="radio__button">
                                                    <input
                                                      type="radio"
                                                      class="radio__input variant_radio_input"
                                                      data-single-option-selector
                                                      data-index="option{{ option.position }}"
                                                      name="${option.name}"
                                                      value='${option.values[index]}'
                                                      id="${input_id}"
                                                      ${currentItem}>
                                                    <label for="${input_id}" class="radio__label">
                                                      <span>${option.values[index]}</span>
                                                    </label>
                                                  </span>`
                                              }
                                              returnText += `</fieldset>`
                                              return returnText;
                                            }
                                          }
                                        }).join('')+`
                                      </div>
                                      <div class="title-with-price">`+
                                        item.variants.map((card, index) => {
                                          if(card.id == selectedVariantId){
                                            let option = '';
                                            let hideComparePrice = '';
                                            let variantName = card.title;
                                            let cardPrice = Number(card.price/100).toFixed(2);
                                            if (card.compare_at_price === card.price || !card.compare_at_price) {
                                                hideComparePrice = 'hidden';
                                            }
                                            
                                            return `<div class="price-wrapper ${option}" data-variant-name='${variantName}' data-variant-id="${card.id}" data-inventory-quantity="${card.inventory_quantity}">
                                                        <div class="variant-with-price">
                                                            <span class="sizeValue">(${sizeValue})</span>
                                                            <span class="variant_price" data-price="${cardPrice}">$${cardPrice}</span>
                                                            <span class="product__price--compare ${hideComparePrice}">$${card.compare_at_price}</span>
                                                        </div>
                                                    </div>`;
                                          }
                                        }).join('') + `
                                        <button class="cross_product-checked ${checkAddButton}" type="submit" name="add" data-add-to-cart ${disabledButton}>
                                          <span class="icon-plus">
                                            <svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m13.5113 6.026h-5.53803v-5.538h-1.924v5.538h-5.563996v1.924h5.563996v5.564h1.924v-5.564h5.53803z" fill="currentColor"></path></svg>
                                          </span>
                                          <span class="add_button">${textButton}</span>
                                        </button>
                                      </div>
                                      <div class="popup-mulberry-inner"></div>
                                      <span class="quick_purchase_button">I don't want to protect my purchase</span>
                                      <div class='product_description'>${quickViewDescription}</div>
                                    </div>
                                  </div>
                                </form>`;
                                document.querySelector('.rebuy_popup-wrapper').innerHTML = productsBody;
                                document.querySelector('.popup-overlay').classList.add('active');
                                document.querySelector('body').classList.add('overflow');
                                popupVariantSwap();
                                productPopupWidget();
                                document.querySelector('.close_popup').addEventListener('click', function(){
                                  document.querySelector('.popup-overlay').classList.remove('active');
                                  document.querySelector('body').classList.remove('overflow');
                                })
                                document.querySelector('.quick_purchase_button').addEventListener('click', function(){
                                  document.querySelector('.rebuy_popup-wrapper .mulberry-id').innerHTML = '';
                                  document.querySelector('.rebuy_popup-wrapper .cross_product-checked').click();
                                })
                                initializeMulberry(variantTitle, variantPrice, variantSku, variantId, container);
                      })
                    .catch(error => {
                        console.error('There was a problem with the fetch operation:', error);
                  });
              })
              .catch(error => {
                  console.error('There was a problem with the fetch operation:', error);
            });
          }
      })
    }

    document.querySelector('.select-popout__item--current a').click();

    document.querySelector('.custom_add-button').addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      document.querySelector('.product__submit__holder .product__submit__buttons .product__submit__add').click();
    })

    window.onload = (event) => {
      let stickyATC = document.querySelector('.sticky-atc');
      var formHeight = 0;
      function triggerStickyAtc() {
        let fromBottom = document.querySelector('.product-submit-form').offsetTop + document.querySelector('.product-submit-form').offsetHeight
        if(window.scrollY > fromBottom - 100 && !document.getElementById('SiteHeader').classList.contains('sticky-form')) {
          console.log('netomi first if');
          console.log('netomi SiteHeader: ', !document.getElementById('SiteHeader').classList.contains('sticky-form'))
          document.getElementById('SiteHeader').classList.add('sticky-form');
          document.querySelector('body').classList.add('sticky-add-to-cart');
          stickyATC.appendChild(document.querySelector('.product__title-and-price'));
          // stickyATC.appendChild(document.querySelector('.product__form__wrapper'));
          if(window.innerWidth < 767) {
            const netomiIcon = document.querySelector('#netomiChatWindow');
            netomiIcon.style.display = 'none';
            // netomiIcon.style.bottom = '35%';
          }
          
        }
        if(!document.querySelector('.product-submit-form').querySelector('.product__form__wrapper')) {
          document.querySelector('.product-submit-form').style.minHeight = `${formHeight}px`;
          if(window.innerWidth < 767) {
            console.log('hiding netomi icon');
            const netomiIcon = document.querySelector('#netomiChatWindow');
            netomiIcon.style.display = 'block';
            console.log('netomiIcon: ', netomiIcon);
            // netomiIcon.style.bottom = '35%';
          }
        }
        else {
          formHeight = document.querySelector('.product-submit-form').querySelector('.product__form__wrapper').offsetHeight;
          document.querySelector('.product-submit-form').style.minHeight = 0;
        }
        if(window.scrollY <= fromBottom - 100 && document.getElementById('SiteHeader').classList.contains('sticky-form')) {
          console.log('netomi SiteHeader: ', !document.getElementById('SiteHeader').classList.contains('sticky-form'))
          document.getElementById('SiteHeader').classList.remove('sticky-form');
          document.querySelector('body').classList.remove('sticky-add-to-cart');
          document.querySelector('.form__wrapper').prepend(document.querySelector('.product__title-and-price'));
          // document.querySelector('.product-submit-form').prepend(document.querySelector('.product__form__wrapper'));
          if(window.innerWidth < 767) {
            const netomiIcon = document.querySelector('#netomiChatWindow');
            netomiIcon.style.display = 'block';
            // netomiIcon.style.bottom = '15px';
          }
        }
      }
      window.addEventListener("scroll", (event) => {
        triggerStickyAtc();
      });

      window.NETOMI_WEB_WIDGET.subscribe('MINIMIZE_CHAT_WIDGET', (data) => {
        console.log('netomi widget minimized')
        triggerStickyAtc();
      })

      triggerStickyAtc();
      document.querySelectorAll('.select-popout__item').forEach(item => {
        item.addEventListener('click', function(){
          if(this.classList.contains('sold-out')) {
            document.querySelector('.product__form__wrapper').classList.add('variant--soldout');
            document.querySelectorAll('[data-add-to-cart-text]').forEach(atc => {
              atc.textContent = 'Sold Out - Notify Me When It\'s Available';
            });
            if(document.querySelector('.product__submit__item.atc_button:not(.hidden)'))
              document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('.product__submit__add').disabled = true;
          }
          else {
            document.querySelector('.product__form__wrapper').classList.remove('variant--soldout');
            document.querySelectorAll('[data-add-to-cart-text]').forEach(atc => {
              atc.textContent = 'Add to Cart';
            });
            if(document.querySelector('.product__submit__item.atc_button:not(.hidden)'))
              document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('.product__submit__add').disabled = false;
          }
        });
      });
      document.querySelector('.select-popout__list-close')?.addEventListener('click', function(){
        document.querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
        document.querySelector('.select-popout__toggle').setAttribute('aria-expanded', false);
      });
    };

    function initSwiper(){
      var galleryThumbs = new Swiper(`.product-single__gallery .gallery-thumbs`, {
        centeredSlides: true,
        spaceBetween: 10,
        slideToClickedSlide: true,
        slidesPerView: 8,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });

      var galleryTop = new Swiper(`.product-single__gallery  .gallery-top`, {
        loop: true,
        loopedSlides: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: `.product-single__gallery .swiper-button-next`,
          prevEl: `.product-single__gallery .swiper-button-prev`,
        },
        pagination: {
          el: ".product-single__gallery .swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return '<li class="' + className + '" data-pagination-index="'+(index+1)+'"></li>';
          },
        },
        on: {
          init: function () {
            updateTabIndex();
            let el = document.querySelector('.gallery-top .swiper-wrapper');
            if (el) {
              setTimeout(() => {
                el.removeAttribute('aria-live');
              }, 1000);
            }
          },
          slideChangeTransitionEnd: function () {
            updateTabIndex();
          }
        }
      });

      function updateTabIndex() {
        document.querySelectorAll('.gallery-top .swiper-slide').forEach(slide => {
          if (slide.classList.contains('swiper-slide-active')) {
            slide.setAttribute('tabindex', '0');
          } else {
            slide.setAttribute('tabindex', '-1');
          }
        });
      }

      setTimeout(() => {
        let swiperWrapper = document.querySelector('.product-single__gallery .gallery-thumbs .swiper-wrapper');

        // Check if it exists and has the aria-live attribute, then remove it
        if (swiperWrapper && swiperWrapper.hasAttribute('aria-live')) {
          swiperWrapper.removeAttribute('aria-live');
        }
        swiperWrapper.querySelectorAll('.swiper-slide').forEach(item => {
          item.removeAttribute('role');
          item.removeAttribute('aria-label');
        })
      }, 1000);

      document.querySelector('.product-single__gallery .gallery-thumbs')?.querySelectorAll('.swiper-slide').forEach(slider => {
        slider.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          let index = this.querySelector('.product-single__thumbnail').dataset.number;
          document.querySelector('.product-single__gallery').querySelector(`[data-pagination-index="`+index+`"`).click();
          document.querySelector('.product-single__gallery .gallery-thumbs')?.querySelectorAll('.swiper-slide').forEach(slide => {
            slide.querySelector('.product-single__thumbnail-link').removeAttribute('aria-current');
          })
          this.querySelector('.product-single__thumbnail-link').setAttribute('aria-current', true);
        })
        slider.querySelector('.product-single__thumbnail-link')?.addEventListener('keydown', (e) =>{
          if(e.code == 'Space' || e.key == 'Enter'){
            e.preventDefault();
            e.stopPropagation();
            slider.click();
          }
        })
      })
    }

    

    function swapProduct(){
      document.querySelectorAll('.swap-product__button').forEach(radioButton => {
        radioButton.addEventListener('change', function(){
          let radioValue = document.querySelector('.zin-radio__button .variant_radio_input:checked ').dataset.value;
          let materialValue = document.querySelector('.zin-material-radio .zin-radio__input:checked').dataset.value;
          let productUrl = '';
          let selectedId = '';
          if(radioValue.includes('Ultra Cooling')){
            radioValue = radioValue.replace('Ultra Cooling', 'Ultra-Cool');
          }
          document.querySelectorAll('.zinus_product').forEach(zinusProduct => {
            let zinusProductTitle = zinusProduct.dataset.productTitle;
            
            if(zinusProductTitle.includes('Ultra Cooling'))
              {
                zinusProductTitle = zinusProductTitle.replace('Ultra Cooling', 'Ultra-Cool');
              }
            if(zinusProductTitle.includes(radioValue) && zinusProductTitle.includes(materialValue)){

              let getVariantData = zinusProduct.querySelector('[type="application/json"]').textContent;
              let sizeOption = document.querySelector('.select-popout__item--current .select-popout__option')?.dataset.value;
              let options = [];
              getVariantData = JSON.parse(getVariantData);
              if(sizeOption)
                options.push(sizeOption);
              let currentVariant = getVariantData.find((variant) => {
                return options[0] === variant.title;
              });
              selectedId = currentVariant.id;
              productUrl = zinusProduct.dataset.productUrl+`?variant=${selectedId}`;
            }
          })

          window.location.href = productUrl;
        })
      })
    }

    if(document.querySelector('.cross_widget')){
      document.querySelector('.cross_widget #cross_widget').addEventListener('change', function(){
        if(document.querySelector('.cross_widget #cross_widget').checked){
          let variantId = document.querySelector('.cross_widget .product_title').dataset.productId;
          document.querySelector('.cross_widget_product').innerHTML = `<input type="hidden" name="items[1][id]" value="${variantId}">`;
          document.querySelector('.upsell-products__id-wrapper').innerHTML = `<input type="hidden" name="items[2][id]" value="${variantId}">`;
        }else{
          document.querySelector('.cross_widget_product').innerHTML = '';
          document.querySelector('.upsell-products__id-wrapper').innerHTML = '';
        }
      })
    }

    /* Custom Buy Now Button Function */

    document.querySelector('.custom-buy-button').addEventListener('click', async function(event){
      event.preventDefault(); // Prevent form submission
      let selectedId = document.querySelector('[data-selected-id').dataset.selectedId;
      addToCart('', selectedId);
    })

    function addToCart(mulberryId, variantId){
      let formData = [];
      if(mulberryId){
        formData = {
          'items': [
            {
            'id': variantId,
            'quantity': 1
            },
            {
              'id': mulberryId,
              'quantity': 1
            }
          ]
        }
      }else{
        formData = {
          'items': [
            {
            'id': variantId,
            'quantity': 1
            }
          ]
        }
      }
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(function(json) {
        console.log(json, 'json');
        window.location.href = '/checkout';
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }

    const upsellModalBtn = document.querySelectorAll(".upsell-popup__button");
    const upsellModal = document.querySelector(".upsell-popup__wrapper");
    const upsellCancelBtn = document.querySelector("#closeUpsellModalBtn");

    upsellModalBtn?.forEach(button => {
      button?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        upsellModal.classList.remove('hidden');
        let chatIcon = document.querySelector('#netomiChatWindow');
        chatIcon.style.zIndex = '999';
      })
    })

    upsellCancelBtn?.addEventListener('click', () => {
      upsellModal?.classList.add('hidden');
      let chatIcon = document.querySelector('#netomiChatWindow');
      chatIcon.style.zIndex = '21474';
    })

    document.querySelector('.upgrade_button').addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      let upsellId = document.querySelector('.upsell-popup__container .upsell-product__id').value;
      let originProductId = document.querySelector('.upsell-popup__container .product__id').value;
      document.querySelector('.upsell-popup__container [data-product-id]').value = upsellId;
      document.querySelector('.upsell-popup__container [data-add-to-cart]').click();
      document.querySelector('.upsell-popup__container [data-product-id]').value = originProductId;
    })
      
  });